<template>
  <card titulo="Histórico">

    <auditoria-pagination :referencia="ficha.id" entidade="INDICADOR_REAL" />

  </card>
</template>

<script>
  import Card from "@/components/Layout/components/Card.vue";

  export default {

    name: "Histórico",
    components: {
      Card,
      AuditoriaPagination: () => import('@/v2/components/Auditoria/AuditoriaPagination')
    },
    props: {
      ficha : Object
    },

    data() {
      return {
        historico : [],
        loading: true,
        disable: false,
        page: 1,
        pageSize: 10
      }
    },

    methods:{}
  }
</script>
